import { render, staticRenderFns } from "./ReservationCharges.vue?vue&type=template&id=5336a2c5&scoped=true"
import script from "./ReservationCharges.vue?vue&type=script&lang=js"
export * from "./ReservationCharges.vue?vue&type=script&lang=js"
import style0 from "./ReservationCharges.vue?vue&type=style&index=0&id=5336a2c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336a2c5",
  null
  
)

export default component.exports